'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faFacebook = require('@fortawesome/fontawesome-free-brands/faFacebook');
var _faFacebook2 = _interopRequireDefault(_faFacebook);
var _faFacebookF = require('@fortawesome/fontawesome-free-brands/faFacebookF');
var _faFacebookF2 = _interopRequireDefault(_faFacebookF);
var _faTwitter = require('@fortawesome/fontawesome-free-brands/faTwitter');
var _faTwitter2 = _interopRequireDefault(_faTwitter);
var _faTwitterSquare = require('@fortawesome/fontawesome-free-brands/faTwitterSquare');
var _faTwitterSquare2 = _interopRequireDefault(_faTwitterSquare);
var _faPinterest = require('@fortawesome/fontawesome-free-brands/faPinterest');
var _faPinterest2 = _interopRequireDefault(_faPinterest);
var _faPinterestP = require('@fortawesome/fontawesome-free-brands/faPinterestP');
var _faPinterestP2 = _interopRequireDefault(_faPinterestP);
var _faPinterestSquare = require('@fortawesome/fontawesome-free-brands/faPinterestSquare');
var _faPinterestSquare2 = _interopRequireDefault(_faPinterestSquare);
var _faInstagram = require('@fortawesome/fontawesome-free-brands/faInstagram');
var _faInstagram2 = _interopRequireDefault(_faInstagram);
var _faYoutube = require('@fortawesome/fontawesome-free-brands/faYoutube');
var _faYoutube2 = _interopRequireDefault(_faYoutube);
var _faYoutubeSquare = require('@fortawesome/fontawesome-free-brands/faYoutubeSquare');
var _faYoutubeSquare2 = _interopRequireDefault(_faYoutubeSquare);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var SocialLinks = function (_React$Component) {
  _inherits(SocialLinks, _React$Component);
  function SocialLinks() {
    _classCallCheck(this, SocialLinks);
    var _this = _possibleConstructorReturn(this, (SocialLinks.__proto__ || Object.getPrototypeOf(SocialLinks)).call(this));
    _this.facebookIcon = _this.facebookIcon.bind(_this);
    _this.pinterestIcon = _this.pinterestIcon.bind(_this);
    _this.twitterIcon = _this.twitterIcon.bind(_this);
    _this.youtubeIcon = _this.youtubeIcon.bind(_this);
    _this.generateComponent = _this.generateComponent.bind(_this);
    return _this;
  }
  _createClass(SocialLinks, [{
    key: 'facebookIcon',
    value: function facebookIcon() {
      switch (this.props.facebookIcon) {
        case 'square':
          return _faFacebook2.default;
        default:
          return _faFacebookF2.default;
      }
    }
  }, {
    key: 'pinterestIcon',
    value: function pinterestIcon() {
      switch (this.props.pinterestIcon) {
        case 'p':
          return _faPinterestP2.default;
        case 'square':
          return _faPinterestSquare2.default;
        default:
          return _faPinterest2.default;
      }
    }
  }, {
    key: 'twitterIcon',
    value: function twitterIcon() {
      switch (this.props.twitterIcon) {
        case 'square':
          return _faTwitterSquare2.default;
        default:
          return _faTwitter2.default;
      }
    }
  }, {
    key: 'youtubeIcon',
    value: function youtubeIcon() {
      switch (this.props.youtubeIcon) {
        case 'square':
          return _faYoutubeSquare2.default;
        default:
          return _faYoutube2.default;
      }
    }
  }, {
    key: 'generateComponent',
    value: function generateComponent(service) {
      switch (service) {
        case 'facebook':
          return _react2.default.createElement('a', {
            className: 'social-links__link social-links__link--facebook',
            href: 'https://www.facebook.com/' + this.props.facebookUsername,
            key: _shortid2.default.generate(),
            target: '_blank',
            rel: 'noopener',
            'aria-label': 'Facebook'
          }, _react2.default.createElement(_reactFontawesome2.default, {
            icon: this.facebookIcon()
          }));
        case 'instagram':
          return _react2.default.createElement('a', {
            className: 'social-links__link social-links__link--instagram',
            href: 'https://www.instagram.com/' + this.props.instagramUsername,
            key: _shortid2.default.generate(),
            rel: 'noopener',
            target: '_blank',
            'aria-label': 'Instagram'
          }, _react2.default.createElement(_reactFontawesome2.default, {
            icon: _faInstagram2.default
          }));
        case 'twitter':
          return _react2.default.createElement('a', {
            className: 'social-links__link social-links__link--twitter',
            href: 'https://twitter.com/' + this.props.twitterUsername,
            key: _shortid2.default.generate(),
            target: '_blank',
            rel: 'noopener',
            'aria-label': 'Twitter'
          }, _react2.default.createElement(_reactFontawesome2.default, {
            icon: this.twitterIcon()
          }));
        case 'pinterest':
          return _react2.default.createElement('a', {
            className: 'social-links__link social-links__link--pinterest',
            href: 'https://www.pinterest.com/' + this.props.pinterestUsername,
            key: _shortid2.default.generate(),
            target: '_blank',
            rel: 'noopener',
            'aria-label': 'Pinterest'
          }, _react2.default.createElement(_reactFontawesome2.default, {
            icon: this.pinterestIcon()
          }));
        case 'youtube':
          return _react2.default.createElement('a', {
            className: 'social-links__link social-links__link--youtube',
            href: 'https://www.youtube.com/user/' + this.props.youtubeUsername,
            key: _shortid2.default.generate(),
            target: '_blank',
            rel: 'noopener',
            'aria-label': 'Youtube'
          }, _react2.default.createElement(_reactFontawesome2.default, {
            icon: this.youtubeIcon()
          }));
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      return _react2.default.createElement('div', {
        className: 'social-links ' + this.props.className
      }, this.props.services.map(function (service) {
        return _this2.generateComponent(service);
      }));
    }
  }]);
  return SocialLinks;
}(_react2.default.Component);
SocialLinks.defaultProps = {
  className: '',
  facebookIcon: 'default',
  facebookUsername: '',
  instagramUsername: '',
  pinterestIcon: 'default',
  pinterestUsername: '',
  twitterIcon: 'default',
  twitterUsername: '',
  youtubeIcon: 'default',
  youtubeUsername: '',
  services: ['twitter', 'facebook', 'instagram']
};
SocialLinks.propTypes = {
  className: _propTypes2.default.string,
  facebookIcon: _propTypes2.default.string,
  facebookUsername: _propTypes2.default.string,
  instagramUsername: _propTypes2.default.string,
  pinterestIcon: _propTypes2.default.string,
  pinterestUsername: _propTypes2.default.string,
  twitterIcon: _propTypes2.default.string,
  twitterUsername: _propTypes2.default.string,
  youtubeIcon: _propTypes2.default.string,
  youtubeUsername: _propTypes2.default.string,
  services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['facebook', 'instagram', 'pinterest', 'twitter', 'youtube']))
};
exports.default = SocialLinks;